import React, { useRef, useState } from "react";
import ReactDOM from 'react-dom';
import LiveDraftTooltip from "./LIveDraftTooltip";
import { Link } from "react-router";
import { PRODUCT_TYPE_CHILD, PRODUCT_TYPE_PARENT, PRODUCT_TYPE_PRODUCT } from "Pages/GMS/Products/constants";

type TLiveDraftButtonProps = {
    item?: any;
    type?: 'id' | 'product';
    rowIndex?: number;
}

const LiveDraftButton = ({
    item,
    type = 'id',
    rowIndex
}: TLiveDraftButtonProps) => {
    const [showTooltip, setShowTooltip] = useState<[boolean, string|null]>([false, null]);
    const divRef = useRef<HTMLDivElement>(null);
    const tooltipRef = useRef<HTMLDivElement>(null);

    const portalRoot = document.getElementById('tooltip-portal') as HTMLDivElement;

    const handleClose = (e: React.MouseEvent<any>) => {
    };

    if (type === 'id') {
        return (
            <div
                ref={divRef}
                onMouseLeave={() => setShowTooltip([false, null])}
                onMouseEnter={() => setShowTooltip([true, null])} 
                className={`tw-rounded tw-bg-surface-sunken tw-p-0.5 tw-px-2.5 tw-text-xs tw-cursor-pointer`}
            >
                <span>ID</span>
                {showTooltip[0] &&
                    ReactDOM.createPortal(
                        <LiveDraftTooltip 
                            ref={tooltipRef}
                            id={item.id}
                            relativeRef={divRef.current as HTMLDivElement}
                            handleClose={handleClose}
                            label="UID"
                        />,
                        portalRoot
                    )
                }
            </div>
        );
    }

    return (
        <div
            ref={divRef}
            onMouseLeave={() => setShowTooltip([false, null])}
            onMouseEnter={() => setShowTooltip([true, null])} 
            className={`${(item.product_type === PRODUCT_TYPE_PRODUCT || item.product_type === PRODUCT_TYPE_CHILD) ? "tw-text-accent" : ""} tw-truncate tw-max-w-full tw-block tw-overflow-hidden`}
        >
            <Link
                id={rowIndex !== undefined ? `products-table-row-${rowIndex}-link` : undefined}
                to={item.product_type !== PRODUCT_TYPE_PARENT ? `/gms/product/details/${item.id}` : "#"}
            >
                {item.name}
            </Link>
            {showTooltip[0] &&
                ReactDOM.createPortal(
                    <LiveDraftTooltip 
                        ref={tooltipRef}
                        id={item.name}
                        relativeRef={divRef.current as HTMLDivElement}
                        handleClose={handleClose}
                        label="ProductName"
                    />,
                    portalRoot
                )
            }
        </div>
    );
};

export default LiveDraftButton;